import React from "react";
// Material-UI imports
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

export default function Error({
  error = true,
  message = "There was an issue loading this information. Please contact us for support or try again later."
}) {
  const classes = useStyles();
  if (error) {
    return (
      <div className={classes.error}>
        <Box component="div" className={classes.copy}>
          <small>{message}</small>
        </Box>
      </div>
    );
  }
  return null;
}

const useStyles = makeStyles(theme => ({
  error: {
    position: "relative",
    width: "100%",
    height: "100%"
  },
  copy: {
    position: "absolute",
    top: "40%",
    textAlign: "center",
    width: "100%",
    fontWeight: "normal"
  }
}));
